import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    Box
} from '@mui/material';

const APPOINTMENT_STATUSES = [
    { value: 'booked', label: 'Booked' },
    { value: 'confirmed', label: 'Confirmed' },
    { value: 'arrived', label: 'Arrived' },
    { value: 'completed', label: 'Completed' },
    { value: 'noshow', label: 'No Show' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'paid', label: 'Paid' },
];

export default function ChangeStatusDialog({ open, onClose, appointment, onStatusChange }) {
    const [newStatus, setNewStatus] = useState(appointment?.status || '');
    const [loading, setLoading] = useState(false);

    const handleStatusChange = async () => {
        if (!newStatus || newStatus === appointment?.status) {
            onClose();
            return;
        }

        setLoading(true);
        try {
            await onStatusChange(appointment.id, newStatus);
            onClose();
        } catch (error) {
            // Error is handled in parent component
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Change Appointment Status</DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 2 }}>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        Appointment: {appointment?.startDate} at {appointment?.startTime}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" gutterBottom sx={{ mb: 3 }}>
                        Current Status: <strong style={{ textTransform: 'capitalize' }}>{appointment?.status}</strong>
                    </Typography>

                    <FormControl fullWidth>
                        <InputLabel>New Status</InputLabel>
                        <Select
                            value={newStatus}
                            label="New Status"
                            onChange={(e) => setNewStatus(e.target.value)}
                            disabled={loading}
                        >
                            {APPOINTMENT_STATUSES.map((status) => (
                                <MenuItem key={status.value} value={status.value}>
                                    {status.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>
                    Cancel
                </Button>
                <Button 
                    onClick={handleStatusChange} 
                    variant="contained" 
                    disabled={loading || !newStatus || newStatus === appointment?.status}
                >
                    {loading ? 'Updating...' : 'Update Status'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
